function collectionTab(section) {
    // Find the tabs and content containers specific to this section
    const tabs = section.querySelectorAll("ul.tabs li");
    const contents = section.querySelectorAll(".tab-content");

    if (tabs.length === 0 || contents.length === 0) return;

    // Add event listeners to the tabs
    tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
            // Remove active class from all tabs in this section
            tabs.forEach(t => t.classList.remove("active"));
            // Add active class to the clicked tab
            tab.classList.add("active");

            // Hide all tab contents in this section
            contents.forEach(content => content.classList.remove("active"));
            // Show the related content to the clicked tab
            contents[index].classList.add("active");
        });
    });

    // Optionally trigger the first tab click initially to show default content
    tabs[0].click();
}

// Initialize tabs on page load for all sections
window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll("[data-section='CollectionTab']").forEach(section => {
        collectionTab(section);
    });
});

// Reinitialize tabs when a new section is loaded via Shopify's section editor
document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector("[data-section='CollectionTab']");
    if (section) {
        collectionTab(section);
    }
});
